import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import BidDetail from './BidDetail';
import HotelFeedbackLink from './HotelFeedbackLink';

class BidDetailPanel extends React.Component {
  constructor(props) {
    super(props);
    //get answers data
    const notesData = [];
    let answers = [];
    let pk = this.props.bid.id;
    let proposalId = this.props.proposalId;
    let payload = {'bidId':pk,'proId':proposalId};

    this.props.getNotesBrand(proposalId,payload,(response) =>{
      if(response){
        response.forEach((res) =>{
          notesData.push({
            bid:res.bid,
            proposal:res.proposal,
            author:res.author,
            text:res.text,
          })
        })
      } else{
        console.log("note data not avaiable")
      }
    })

    this.props.requestAnswers(pk, (response) =>{
      if(this.props.addedanswers.answers){
        this.props.addedanswers.answers.forEach((answer) => {
          if(pk == answer.bid_id){
            answers.push({
              id: answer.id,
              bid_id: answer.bid_id,
              question: answer.question,
              answer: answer.answer,
              group_id: answer.group_id,
              tour_id: answer.tour_id
            })
          }

        });
      }else{
        console.log("answers data is not avaiable")
      }
    });

    this.state = {
      answers,
      notesData,
    }

  }
  render() {
    return (
      <div>
        <h4>
          <Button onClick={this.props.onClose}>
            <i className="fa fa-arrow-left" aria-hidden="true" /> Back
          </Button>
        </h4>
        <BidDetail
          profilename={this.props.profilename}
          bid={this.props.bid}
          editBid={this.props.editBid}
          addBidNote={this.props.addBidNote}
          sendBid={this.props.sendBid}
          user={this.props.user}
          requestAnswers={this.props.requestAnswers}
          addAnswers={this.props.addAnswers}
          answerData={this.state.answers}
          notesData={this.state.notesData}
          updateHotelContacts={this.props.updateHotelContacts}
          deleteHotelContacts={this.props.deleteHotelContacts}
          {...this.props}
        />
        <div className="pull-right">
          <HotelFeedbackLink id={this.props.bid.hotel.id} />
        </div>
      </div>
    );
  }
}

BidDetailPanel.propTypes = {
  bid: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  requestAnswers: PropTypes.func.isRequired,
};

BidDetailPanel.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default BidDetailPanel;



// WEBPACK FOOTER //
// src/routes/booking/components/BidDetailPanel.js